import { render, staticRenderFns } from "./luuCVDi.vue?vue&type=template&id=58cc38bc&scoped=true&"
import script from "./luuCVDi.vue?vue&type=script&lang=js&"
export * from "./luuCVDi.vue?vue&type=script&lang=js&"
import style0 from "./luuCVDi.vue?vue&type=style&index=0&id=58cc38bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc38bc",
  null
  
)

export default component.exports